import {initAlpine} from "./init.js";
import { gsap } from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.heroInitAnimation = function () {
  const heroAnimation = gsap.timeline();

  heroAnimation.fromTo(
      '.navbar',
      { y: -100, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.5, ease: 'power3.in' }
  );

  heroAnimation.fromTo(
      ['.hero_main-wrap', '.hero_features-wrap'],
      { y: 50, autoAlpha: 0 }, // Initial state
      {
        y: 0,
        autoAlpha: 1,
        duration: 0.2,
        ease: 'power3.in',
        stagger: 0.1,
      }, '<0.2'
  );

};

window.textVertical = function () {
  // Select the h2 element inside the section with class .section.is-v-text
  const heading = document.querySelector('.section.is-v-text h2');

  if (heading) {
    // Get the original text content
    const textContent = heading.textContent;

    // Clear the original content
    heading.innerHTML = '';

    // Split the text into words and create spans
    textContent.split(' ').forEach(word => {
      const span = document.createElement('span');
      span.className = 'heading-word'; // Add a class for targeting
      span.textContent = word + ' '; // Add space back after word
      heading.appendChild(span);
    });
  }

    const elementsToAnimate = document.querySelectorAll('.section.is-v-text h2 span');


    gsap.to(elementsToAnimate, {
    scrollTrigger: {
      trigger: '.section.is-v-text',
      start: 'top top+=40%',
      end: 'top top+=20%',
      scrub: 1,
      //markers: true,
    },
    color: '#fff',
    stagger: 0.1,
    ease: 'none'
  });
};

window.textHorizontal = function () {
  // Get the elements we need
  const container = document.querySelector('.h-text_main-wrap');
  const heading = document.querySelector('.is-display.is-h-text');

  // Set up the animation
  const setupTextAnimation = function() {
    // First, set the initial position - heading starts outside the container to the left
    gsap.set(heading, {
      x: -((heading.offsetWidth - container.offsetWidth)),
      position: 'relative'
    });

    // Create the scroll animation
    return gsap.from(heading, {
      x: 0, // End position (right edges aligned)
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".section.is-h-text",
        start: "top 60%",
        end: "top top-=20%",
        scrub: true,
        //markers: true,
      }
    });
  };

  // Initial setup
  let textAnimation = setupTextAnimation();

  // Add resize event listener
  window.addEventListener('resize', function() {
    // Kill the previous animation and ScrollTrigger
    if (textAnimation && textAnimation.scrollTrigger) {
      textAnimation.scrollTrigger.kill();
    }
    // Recreate the animation with new dimensions
    textAnimation = setupTextAnimation();
  });
}

window.studioBoxes = function () {
  // Get the elements we need
  const container = document.querySelector('.container.is-studio');
  const boxes = document.querySelector('.studio_marquee-control');

  // Set up the animation
  const setupBoxesAnimation = function() {
    // First, set the initial position - heading starts outside the container to the left
    gsap.set(boxes, {
      x: -((boxes.offsetWidth - container.offsetWidth)),
      position: 'relative'
    });

    // Create the scroll animation
    return gsap.from(boxes, {
      x: 0, // End position (right edges aligned)
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".section.is-studio",
        start: "top+=10% top",
        end: "bottom bottom",
        scrub: true,
        //markers: true,
      }
    });
  };

  // Initial setup
  let boxesAnimation = setupBoxesAnimation();

  // Add resize event listener
  window.addEventListener('resize', function() {
    // Kill the previous animation and ScrollTrigger
    if (boxesAnimation && boxesAnimation.scrollTrigger) {
      boxesAnimation.scrollTrigger.kill();
    }
    // Recreate the animation with new dimensions
    boxesAnimation = setupBoxesAnimation();
  });
}

window.kwadronIcon = function () {
  const icon = document.querySelector('.hitw_tab-1-icon');
  gsap.to(icon, {
    scale: 1.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section.is-hitw",
      start: "top-=50% top",
      end: "bottom+=70% bottom",
      scrub: true,
      //markers: true,
    }
  });

}

window.displayButtons = function () {
  // More reliable OS detection
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Get all buttons by their attributes
  const googleButtons = document.querySelectorAll('[btntype="google"]');
  const appleButtons = document.querySelectorAll('[btntype="apple"]');

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // Hide all Google buttons
    googleButtons.forEach(button => {
      button.style.display = 'none';
    });

    // Show all Apple buttons
    appleButtons.forEach(button => {
      button.style.display = 'flex';
    });
  }
  // Android detection
  else if (/android/i.test(userAgent)) {
    // Hide all Apple buttons
    appleButtons.forEach(button => {
      button.style.display = 'none';
    });

    // Show all Google buttons
    googleButtons.forEach(button => {
      button.style.display = 'flex';
    });
  }
  // Desktop - show both
  else {
    // Show all Apple buttons
    appleButtons.forEach(button => {
      button.style.display = 'flex';
    });

    // Show all Google buttons
    googleButtons.forEach(button => {
      button.style.display = 'flex';
    });
  }
}



// !!!!!!!!! Keep this Alpine init at the end !!!!!!!!!
window.Webflow ||= [];
window.Webflow.push(() => {
  initAlpine();
  textVertical();
  kwadronIcon();
  textHorizontal();
  studioBoxes();
  displayButtons();
  heroInitAnimation();

  // Optional: Add debounce function to prevent excessive recalculations during resize
  function debounce(func, wait = 200) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Replace the direct resize listeners with debounced versions
  const debouncedResize = debounce(function() {
    // Refresh all GSAP ScrollTriggers
    ScrollTrigger.refresh();
  }, 200);

  window.addEventListener('resize', debouncedResize);
});
